<div [ngStyle]="{ height: expanded ? 'initial' : 0 }" [ngClass]="{ 'suspended': name === 'Suspension' }">
  <div pl-grid="1/1@phone nowrap" class="credential-item-header">
    <span pl-grid-el pl-grid="shrink@phone" class="se-app__content-subtitle--med">{{ name }}</span>
    <se-tag
      *ngIf="eligibilityStatusTag"
      pl-grid-el
      pl-grid="shrink@phone"
      se-data-color="{{ eligibilityStatusTag.color }}"
      se-data-value="{{ eligibilityStatusTag.value }}">
    </se-tag>
  </div>
  <div class="se-text">{{ validityLabel }}</div>
</div>
